(() => {
  const CART_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path fill="currentColor" d="M3.5 4h1.2l.3 1.2 1.4 7.1A1.75 1.75 0 0 0 7.9 14h7.35a1.75 1.75 0 0 0 1.7-1.35l1.2-5.1A.9.9 0 0 0 17.3 6H5.7l-.35-1.45A1.5 1.5 0 0 0 3.9 3.4H2.4a.75.75 0 0 0 0 1.5h1.1ZM8.2 17.2a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2Zm6.8 0a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2Z"/></svg>`;

  const initStickyAtc = () => {
    const bar = document.querySelector('[data-sz-sticky-atc]');
    if (!bar || bar.dataset.szInit === 'true') return;

    const submitId = bar.getAttribute('data-submit-id');
    const sectionId = bar.getAttribute('data-section-id');
    const mainSubmit = submitId ? document.getElementById(submitId) : null;
    const stickySubmit = bar.querySelector('[data-sz-sticky-submit]');
    const stickyLabel = bar.querySelector('[data-sz-sticky-label]');
    if (!mainSubmit || !stickySubmit) return;

    bar.dataset.szInit = 'true';

    const setVisible = (visible) => {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('sz-sticky-atc-active', visible);
    };

    const syncState = () => {
      stickySubmit.disabled = Boolean(mainSubmit.disabled);

      if (stickyLabel) {
        const sourceLabel = mainSubmit.querySelector('.sz-pdp-atc-label');
        const text = (sourceLabel || mainSubmit).textContent.replace(/\s+/g, ' ').trim();
        const available = !mainSubmit.disabled && !/sold out|unavailable/i.test(text);
        stickyLabel.innerHTML = available ? `${CART_ICON}${text}` : text;
      }

      if (sectionId) {
        const priceRoot = document.getElementById(`price-${sectionId}`);
        const stickyPrices = bar.querySelectorAll('[data-sz-sticky-price], [data-sz-sticky-price-desktop]');
        if (priceRoot && stickyPrices.length) {
          const onSale = priceRoot.querySelector('.price--on-sale');
          const sale = priceRoot.querySelector('.price-item--sale');
          const regular = priceRoot.querySelector('.price-item--regular');
          const active = onSale ? sale || regular : regular || sale;
          if (active) {
            const value = active.textContent.trim();
            stickyPrices.forEach((el) => {
              el.textContent = value;
            });
          }
        }
      }
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(!entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: '0px 0px -10% 0px',
      }
    );

    observer.observe(mainSubmit);

    // Fallback: also toggle after user scrolls past the main button
    const onScroll = () => {
      const rect = mainSubmit.getBoundingClientRect();
      setVisible(rect.bottom < 0 || rect.top > window.innerHeight);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    stickySubmit.addEventListener('click', (event) => {
      event.preventDefault();
      if (mainSubmit.disabled) return;
      mainSubmit.click();
    });

    syncState();

    const mo = new MutationObserver(syncState);
    mo.observe(mainSubmit, { attributes: true, childList: true, subtree: true });

    const priceRoot = sectionId ? document.getElementById(`price-${sectionId}`) : null;
    if (priceRoot) {
      const priceMo = new MutationObserver(syncState);
      priceMo.observe(priceRoot, { childList: true, subtree: true, characterData: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc, { once: true });
  } else {
    initStickyAtc();
  }

  document.addEventListener('shopify:section:load', () => {
    const bar = document.querySelector('[data-sz-sticky-atc]');
    if (bar) delete bar.dataset.szInit;
    initStickyAtc();
  });
})();


(() => {
  const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

  const getEndTime = (el) => {
    const mode = el.dataset.mode || 'end_of_day';
    if (mode === 'fixed' && el.dataset.end) {
      const parsed = Date.parse(el.dataset.end);
      if (!Number.isNaN(parsed)) return parsed;
    }
    const end = new Date();
    end.setHours(23, 59, 59, 999);
    return end.getTime();
  };

  const tick = (el) => {
    const end = getEndTime(el);
    let diff = Math.max(0, end - Date.now());
    if (diff <= 0 && (el.dataset.mode || 'end_of_day') === 'end_of_day') {
      // roll to next midnight
      const next = new Date();
      next.setDate(next.getDate() + 1);
      next.setHours(23, 59, 59, 999);
      diff = Math.max(0, next.getTime() - Date.now());
    }
    const totalSec = Math.floor(diff / 1000);
    const hours = Math.floor(totalSec / 3600);
    const minutes = Math.floor((totalSec % 3600) / 60);
    const seconds = totalSec % 60;
    const h = el.querySelector('[data-sz-hours]');
    const m = el.querySelector('[data-sz-minutes]');
    const s = el.querySelector('[data-sz-seconds]');
    if (h) h.textContent = pad(hours);
    if (m) m.textContent = pad(minutes);
    if (s) s.textContent = pad(seconds);
  };

  const initTimers = () => {
    document.querySelectorAll('[data-sz-sale-timer]').forEach((el) => {
      if (el.dataset.szTimerInit === 'true') return;
      el.dataset.szTimerInit = 'true';
      tick(el);
      window.setInterval(() => tick(el), 1000);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTimers, { once: true });
  } else {
    initTimers();
  }
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-sz-sale-timer]').forEach((el) => delete el.dataset.szTimerInit);
    initTimers();
  });
})();
